import moment from 'moment-timezone';
import Client from 'classes/Client.js';
import Request from 'files/Request.js';

class UserClass {

    active = null;
    address = null;
    avatar = null;
    client = null;
    client_id = null;
    date = null;
    email_address = null;
    first_name = null;
    full_name = null;
    last_login = null;
    last_name = null;
    level = null;
    location = null;
    permissions = null;
    phone_number = null;
    preferences = null;
    spouse = null;
    timezone = moment.tz.guess();
    token = null;
    user_id = null;
    username = null;

    constructor() {
        return this;
    }

	create = (props = {}) => {
        this.active = props.active;
		this.address = props.address;
		this.avatar = props.avatar;
		this.date = props.date;
        this.client = props.client && Client.create(props.client);
        this.client_id = props.client_id;
        this.email_address = props.email_address;
		this.first_name = props.first_name;
		this.full_name = props.full_name;
        this.last_login = props.last_login;
		this.last_name = props.last_name;
        this.level = props.level;
        this.location = props.location && {
            latitude: props.location.lat,
            longitude: props.location.long
        };
		this.password = props.password;
        this.permissions = props.permissions;
		this.phone_number = props.phone_number;
        this.preferences = props.preferences;
        this.spouse = props.spouse;
        this.timezone = props.timezone;
		this.token = props.token;
		this.user_id = props.user_id;
		this.username = props.username;
        return this;
	}
}

export const fetchUser = async (utils, userID) => {
    return new Promise(async (resolve, reject) => {
        try {
            let { user } = await Request.get(utils, '/users/', {
                type: 'details',
                user_id: userID
            });
            resolve(new UserClass().create(user));
        } catch(e){
            reject(e);
        }
    })
}

const levels = {
    system_admin: 1,
    admin: 1000,
    sales_lead: 5000,
    primary: 8000,
    setter: 8500,
    sales_ops: 9000,
    customer: 9999
}

const levelToText = code => {
    switch(code) {
        case levels.system_admin:
        return 'System Admin';

        case levels.admin:
        return 'Admin';

        case levels.sales_lead:
        return 'Sales Lead';

        case levels.primary:
        return 'Primary User';

        case levels.setter:
        return 'Setter';

        case levels.sales_ops:
        return 'Sales Operative';

        case levels.customer:
        return 'Customer';

        default:
        return 'Unknown account type';
    }
}

export default {
    new: () => new UserClass(),
    get: (utils, userID) => fetchUser(utils, userID),
    create: props => new UserClass().create(props),
    levels: {
        get: () => levels,
        toText: levelToText
    }
};
